import { useCallback } from "react";

export type TablaCustomEventArticleProps = {
  event: string;
  visitorcat?: string | number;
  at?: string;
  svc?: string;
  contentcat?: 1; // free (1)
  contentType?: string;
  keyword?: string;
  title?: string;
  author?: string;
  pubdate?: string;
  articleid?: string;
  cue_articleid?: string;
  cd_version?: string;
  url?: string;
  pagination?: number;
  clickCategory?: string;
  clickAction?: string;
  clickLabel?: string;
  chapter1?: string;
  level2?: string;
  landingPage?: string;
  nextNodeTitle?: string;
  nextNodeUrl?: string;
  virtual_url?: string;
};

export function useTablaCustomEventAnalyticsCall(): (
  data: TablaCustomEventArticleProps,
) => void {
  // Destructuring the properties from the argument
  const analyticsCall = useCallback((data: TablaCustomEventArticleProps) => {
    window.dataLayer.push({
      event: data.event,
      ...(data.contentType && { contentType: data.contentType }),
      ...(data.articleid && { articleid: data.articleid }),
      ...(data.title && { title: data.title }),
      ...(data.visitorcat && { visitorcat: data.visitorcat }),
      ...(data.at && { at: data.at }),
      ...(data.svc && { svc: data.svc }),
      ...(data.contentcat && { contentcat: data.contentcat }),
      ...(data.keyword && { keyword: data.keyword }),
      ...(data.author && {
        author: data.author,
      }),
      ...(data.pubdate && { pubdate: data.pubdate }),
      ...(data.cue_articleid && { cue_articleid: data.cue_articleid }),
      ...(data.cd_version && { cd_version: data.cd_version }),
      ...(data.url && { url: data.url }),
      ...(data.pagination && { pagination: data.pagination }),
      ...(data.clickCategory && { clickCategory: data.clickCategory }),
      ...(data.clickAction && { clickAction: data.clickAction }),
      ...(data.clickLabel && { clickLabel: data.clickLabel }),
      ...(data.chapter1 && { chapter1: data.chapter1 }),
      ...(data.level2 && { level2: data.level2 }),
      ...(data.landingPage && { landingPage: data.landingPage }),
      ...(data.nextNodeTitle && { nextNodeTitle: data.nextNodeTitle }),
      ...(data.nextNodeUrl && { nextNodeUrl: data.nextNodeUrl }),
      ...(data.virtual_url && { virtual_url: data.virtual_url }),
    });
  }, []);

  return analyticsCall;
}
